import { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import moment from "moment";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import BaseLayout from "../../components/BaseLayout";
import IconSosmed from "./iconSosmed";
import Comment from "./comment";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import DetailLikeComment from "./detailLikeComment";
import BannerSlider from "../../components/BannerSlider";
import PostComment from "./postComment";
import ApiUtils from "../../utils/api_utils";
import {
  TwitterShareButton,
  WhatsappShareButton,
  FacebookShareButton,
} from "react-share";
import "./style.scss";

const DetailNews = (props) => {
  const {
    getFeedsDetail,
    feedDetail,
    getComment,
    totalComment,
    listComment,
    dataAllLike,
    getAllLike,
    postLike,
    deleteLike,
    postBookmark,
    deleteBookmark,
  } = props;

  const params = useParams();
  const { search } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [dataImg, setDataImg] = useState([]);
  const [isVideo, setIsVideo] = useState(false);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    getFeedsDetail(params.id).then((result) => {
      mappingImg(result.data);
    });
    getComment(params.id);
    getAllLike(params.id);
  }, []);

  const mappingImg = (data) => {
    let dataMap = [];

    if (data.vid_thumb && data.video) {
      dataMap.push({
        images: {
          img: {
            display: data.vid_thumb,
          },
          redirect_uri: data.redirect_uri,
        },
        video: data.video,
      });
      setIsVideo(true);
    } else {
      if (data?.images?.img) {
        dataMap.push({
          images: {
            img: data?.images.img,
          },
          redirect_uri: data.redirect_uri,
        });
      }
      if (data?.images?.img2) {
        dataMap.push({
          images: {
            img: data?.images.img2,
          },
          redirect_uri: data.redirect_uri,
        });
      }
      if (data?.images?.img3) {
        dataMap.push({
          images: {
            img: data?.images?.img3,
          },
          redirect_uri: data.redirect_uri,
        });
      }
    }

    Promise.all(dataMap).then((result) => {
      setDataImg(result);
    });
  };

  const handleBookmark = () => {
    if (feedDetail.favorite) {
      deleteBookmark({ id: params.id, idFavorite: feedDetail.favorite });
    } else {
      postBookmark(params.id);
    }
  };

  const handleBack = () => {
    const query = new URLSearchParams(search);
    const isNews = query.get("isNews");

    if (isNews) return PageRoutes.news;
    return PageRoutes.home;
  };

  const handleShowBanner = () => {
    setIsShow(!isShow);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    handleShowBanner();
  };

  return (
    <>
      {feedDetail.id ? (
        <div className="page-detail-like-comment">
          <BaseLayout
            bottomNavIndex={1}
            header={
              <BannerSlider
                data={dataImg}
                toPath={handleBack()}
                isVideo={isVideo}
                isDisplay={isShow}
              />
            }
            isCustom={true}
          >
            <div className="container wrapper-scroll mt-5">
              <div className="fs-medium text-black-400">{feedDetail.title}</div>
              <div>
                Posted on{" "}
                {moment(feedDetail.created).format("DD MMM YYYY, h:mm A")}
              </div>
              <div className="d-flex mb-2">
                <div className="mr-1">by {feedDetail.creator.name}</div>
              </div>
              <div className="mb-2">
                <IconSosmed
                  isBookmark={true}
                  isShowLike={true}
                  onClick={() => handleBookmark()}
                  onDisplay={() => handleShowBanner()}
                  data={{
                    totalLike: feedDetail.total_like,
                    totalComment: feedDetail.total_comment,
                    totalViews: feedDetail.total_views,
                    idLike: feedDetail.like,
                    idFavorite: feedDetail.favorite,
                    dataAllLike,
                  }}
                />
              </div>
              <div>
                <p>{ReactHtmlParser(feedDetail.description)}</p>
              </div>
              {feedDetail.file ? (
                <>
                  <div className="mb-2">Attached Document</div>
                  <div
                    onClick={() => {
                      window.open(
                        ApiUtils.validateImgUrl({ url: feedDetail.file }),
                        "_blank"
                      );
                    }}
                    className="box-file d-flex align-items-center text-break"
                  >
                    <div>
                      <img
                        src={process.env.PUBLIC_URL + "/icons/icon-pdf.png"}
                        width={30}
                        alt="Icon PDF"
                        className="mr-xs"
                      />
                    </div>
                    <div>
                      {feedDetail.file.substring(
                        feedDetail.file.lastIndexOf("/") + 1
                      )}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="share-social-media">
                <span className="mr-1">Share</span>
                <div className="space">
                  <WhatsappShareButton url={feedDetail?.share_url}>
                    <img
                      src={Assets.iconWhatsappOrange}
                      alt="iconWhatsappOrange"
                    />
                  </WhatsappShareButton>
                </div>
                <div className="space">
                  <FacebookShareButton url={feedDetail?.share_url}>
                    <img
                      src={Assets.iconFacebookOrange}
                      alt="iconFacebookOrange"
                    />
                  </FacebookShareButton>
                </div>
                <div className="space">
                  <TwitterShareButton url={feedDetail?.share_url}>
                    <img
                      src={Assets.iconTwitterOrange}
                      alt="iconTwitterOrange"
                    />
                  </TwitterShareButton>
                </div>
              </div>
              <div className="d-flex justify-content-around">
                <div
                  className="btn border-gray w-50 mr-1"
                  onClick={() => {
                    if (feedDetail.like) {
                      deleteLike({ id: params.id, idLike: feedDetail.like });
                    } else {
                      postLike(params.id);
                    }
                  }}
                >
                  <img
                    src={
                      feedDetail.like
                        ? Assets.iconLikeActive
                        : Assets.iconLikeSolid
                    }
                    alt="iconLikeSolid"
                  />
                  &nbsp;{" "}
                  {feedDetail.like ? (
                    <span className="text-danger">Unlike</span>
                  ) : (
                    "Like"
                  )}
                </div>
                <div className="btn border-gray w-50" onClick={handleToggle}>
                  <img src={Assets.iconCommentSolid} alt="iconCommentSolid" />
                  &nbsp;Comment
                </div>
              </div>
              <div className="mt-3">
                Comments ({totalComment})
                <div className="mt-3">
                  <PostComment />
                </div>
                <Comment
                  onDisplay={() => handleShowBanner()}
                  data={listComment}
                />
              </div>
              <br />
              <br />
            </div>
            {isOpen ? (
              <DetailLikeComment
                title="Comments"
                data={listComment}
                onClick={handleToggle}
              />
            ) : (
              ""
            )}
          </BaseLayout>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  feedDetail: state.FeedsSM.feedDetail,
  totalComment: state.FeedsSM.totalComment,
  listComment: state.FeedsSM.listComment,
  dataAllLike: state.FeedsSM.dataAllLike,
});

const mapDispatchToProps = (dispatch) => ({
  getFeedsDetail: dispatch.FeedsSM.getFeedsDetail,
  getComment: dispatch.FeedsSM.getComment,
  postComment: dispatch.FeedsSM.postComment,
  getAllLike: dispatch.FeedsSM.getAllLike,
  postLike: dispatch.FeedsSM.postLike,
  deleteLike: dispatch.FeedsSM.deleteLike,
  postBookmark: dispatch.FeedsSM.postBookmark,
  deleteBookmark: dispatch.FeedsSM.deleteBookmark,
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailNews);
